<template>
  <div class="order-detail">
    <form @submit.prevent="onGetOrderDetail" class="tw-flex tw-items-center">
      <label for="simple-search" class="tw-sr-only">Search</label>
      <div class="tw-relative tw-w-full">
        <div
          class="tw-flex tw-absolute tw-inset-y-0 tw-left-0 tw-items-center tw-pl-2 tw-pointer-events-none"
        >
          <svg
            class="tw-w-4 tw-h-4 tw-text-gray-500 dark:tw-text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </div>
        <input
          v-model="input"
          type="text"
          class="tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-sm tw-rounded-lg focus:tw-ring-primary focus:tw-border-primary tw-block tw-w-full tw-pl-7 tw-p-2"
          placeholder="Search"
        />
      </div>
    </form>
    <div
      v-if="order"
      class="order-detail tw-my-2 tw-bg-slate-100 tw-rounded-lg tw-text-sm tw-text-left tw-w-full tw-p-4 tw-space-y-1"
    >
      <div class="id">
        Order ID: <span class="tw-text-primary-light">{{ order.orderId }}</span>
      </div>
      <div class="status">
        Delivery On:
        <span class="tw-text-primary-light">{{ formatedDate }}</span>
      </div>
      <div class="status">
        Status: <span class="tw-text-primary-light">{{ status }}</span>
      </div>
      <div class="type">
        Type: <span class="tw-text-primary-light">{{ shippingType }}</span>
      </div>
      <div class="type">
        <span>Customer: </span>
        <span class="group">
          <span class="tw-text-primary-light">{{ formatedCustomerName }}</span>
          <span
            v-if="order.shipping.shippingPhone"
            class="tw-text-primary-light"
          >
            , {{ order.shipping.shippingPhone }}
          </span>
          <span
            v-if="order.shipping.shippingEmail"
            class="tw-text-primary-light"
          >
            , {{ order.shipping.shippingEmail }}
          </span>
        </span>
      </div>
      <div class="delivery-to">
        <span v-if="status === 'PICKUP'">Pickup at: </span>
        <span v-else>Delivery to: </span>
        <span class="tw-text-primary-light">{{ formatedAddress }}</span>
      </div>
      <div class="price">
        Price:
        <span class="tw-text-primary-light">{{
          grandTotal | formatedPrice
        }}</span>
      </div>
      <div class="price">
        Items:
        <div class="tw-text-primary-light tw-pl-4">
          <div
            class="product"
            v-for="product in products"
            :key="product.cprcode"
          >
            <div class="" v-if="product.hema_name_en">
              {{ product.hema_name_en }} x{{ product.quantity }}
            </div>
            <div class="" v-else-if="product.productName">
              {{ product.productName }} x{{ product.quantity }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { mapGetters } from "vuex";
dayjs.extend(localizedFormat);

export default {
  name: "OrderDetail",
  props: {
    orderID: String,
  },
  data() {
    return {
      input: null,
      order: null,
    };
  },
  computed: {
    ...mapGetters({
      selectedRoomID: "chat/selectedRoomID",
    }),
    shippingType() {
      if (this.order.shipping) {
        return this.order.shipping.shippingType;
      }
      return undefined;
    },
    status() {
      if (this.order.payment) {
        return this.order.payment.isPaid ? "Paid" : "Cancelled";
      }
      return this.order.isPaid ? "Paid" : "Cancelled";
    },
    formatedAddress() {
      const shipping = this.order.shipping;
      let text = `${shipping.shippingAddress} ${shipping.shippingSubDistrict} ${shipping.shippingProvince} ${shipping.shippingPostcode}`;
      return text.trim();
    },
    formatedCustomerName() {
      const shipping = this.order.shipping;
      let text = `${shipping.shippingFirstName} ${shipping.shippingLastName}`;
      return text.trim();
    },
    grandTotal() {
      if (this.order) {
        if (this.order.payment) {
          if (this.order.payment.grandTotal >= 0) {
            return this.order.payment.grandTotal;
          }
        }
      }
      if (this.order) {
        if (this.order.grandTotal) {
          return this.order.grandTotal;
        }
      }
      return "";
    },
    products() {
      return this.order.productList;
    },
    formatedDate() {
      return dayjs(this.order?.shipping?.scheduleList[0]?.dateTime).format(
        "LL"
      );
    },
  },
  async activated() {
    console.log("order detail activated", this.orderID);
    if (!this.orderID) return;
    this.order = null;
    try {
      const order = await this.$store.dispatch("chat/getOrderDetail", {
        orderID: this.orderID,
      });
      this.order = order;
    } catch (error) {
      window.alert(`Order ID: ${this.orderID} not found.`);
    } finally {
      this.input = null;
    }
  },
  deactivated() {
    console.log("order detail deactivated");
    this.order = null;
    this.$emit("clear");
  },
  watch: {
    selectedRoomID() {
      this.order = null;
    },
  },
  methods: {
    async onGetOrderDetail() {
      this.order = null;
      try {
        const order = await this.$store.dispatch("chat/getOrderDetail", {
          orderID: this.input,
        });
        this.order = order;
      } catch (error) {
        window.alert(`Order ID: ${this.input} not found.`);
      } finally {
        this.input = null;
      }
    },
  },
  filters: {
    formatedPrice(price) {
      return `฿${price.toLocaleString()}`;
    },
  },
};
</script>

<style>

</style>
